import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import TextAreaInputField from '../TextAreaInputField';
import s from './LimitedTextAreaInputField.scss';
/**
 * One of our standard, plaintext `<textarea />`s.
 *
 * Limits input to a a specified length (`max`) and displays the remaining character allowance in the bottom right of the input.
 */ const LimitedTextAreaInputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { maxLength, value, className } = _param, rest = _object_without_properties(_param, [
        "maxLength",
        "value",
        "className"
    ]);
    var _value_length;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(TextAreaInputField, _object_spread({
        maxLength: maxLength,
        value: value,
        className: c(s['textarea'], className),
        ref: ref
    }, rest)), /*#__PURE__*/ React.createElement("span", {
        className: s['remaining-length']
    }, maxLength - ((_value_length = value === null || value === void 0 ? void 0 : value.length) !== null && _value_length !== void 0 ? _value_length : 0)));
});
LimitedTextAreaInputField.displayName = 'LimitedTextAreaInputField';
export default LimitedTextAreaInputField;
